// customer/Components/Auth/Login.js

import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL, googleAuth } from '../../../config/api';
import axios from 'axios';

function Loginwithgoogle() {

  const navigate = useNavigate()
  const responseGoogle = async (authResult) => {
    try {

      if (authResult) {
      const result = await axios.get(`http://localhost:5454/auth/google?code=${authResult.code}`,{
       // const result = await axios.get(`https://jhonnsbackend.onrender.com/auth/google?code=${authResult.code}`,{
          
        })
        const { email, name, image } = result.data.user
        console.log("result", result.data.user)
        console.log("token", result.data.jwt)

        if (result.data.jwt) localStorage.setItem("jwt", result.data.jwt)
        navigate("/")


      }

      console.log(authResult)
    } catch (err) {
      console.log("error while requesting google", err)
    }
  }

  const googlelogin = useGoogleLogin({
    onSuccess: responseGoogle,
    onError: responseGoogle,
    flow: 'auth-code'
  })

  return (
     <div className="flex justify-center mt-4">
     <button
       className="bg-blue-500 text-white px-6 py-2 rounded-full shadow-lg hover:bg-blue-600 transition duration-200"
       onClick={googlelogin}
     >
       <i className="fab fa-google mr-2"></i>
       Sign In with Google
     </button>
   </div>
  );
}

export default Loginwithgoogle;
